// app/javascript/packs/nested-forms/removeFields.js
class removeFields {
    // This executes when the function is instantiated.
    constructor() {
        this.iterateLinks()
    }

    iterateLinks() {
        // Only attach the listener if it hasn't been attached already
        if (document.body.dataset.removeFieldsListenerAttached === 'true') return

        // Use event delegation to ensure any fields added after the page loads are captured.
        document.addEventListener('click', e => {
            // Check if the clicked element or its parent has the remove_Fields class
            const removeButton = e.target.closest('.remove_Fields')
            if (removeButton) {
                this.handleClick(removeButton, e)
            }
        })

        // Mark as attached
        document.body.dataset.removeFieldsListenerAttached = 'true'
    }

    handleClick(link, e) {
        // Stop the function from executing if a link or event were not passed into the function.
        if (!link || !e) return
        // Prevent the browser from following the URL.
        e.preventDefault()
        // Find the parent wrapper for the set of nested fields.
        let fieldParent = link.closest('.nested-fields')
        // If there is a parent wrapper, find the hidden delete field.
        let deleteField = fieldParent
            ? fieldParent.querySelector('input[type="hidden"]')
            : null
        // If there is a delete field, update the value to `1` and hide the corresponding nested fields.
        if (deleteField) {
            deleteField.value = 1
            fieldParent.style.display = 'none'
        }
    }
}

// Initialize on page load
function initRemoveFields() {
    new removeFields();
}

// Wait for turbo/turbolinks to load, otherwise `document.querySelectorAll()` won't work
window.addEventListener('turbo:load', initRemoveFields);
window.addEventListener('turbo:render', initRemoveFields);
window.addEventListener('turbo:frame-load', initRemoveFields);
window.addEventListener('turbolinks:load', initRemoveFields);
document.addEventListener('DOMContentLoaded', initRemoveFields);

// Also run immediately if document is already loaded
if (document.readyState === 'loading') {
    // Document still loading, wait for DOMContentLoaded
} else {
    // Document already loaded, run immediately
    initRemoveFields();
}

export default removeFields;